module.exports = __webpack_public_path__ + "static/services-3-43f7556f9858df401cb6238d897d98fb.jpg";